import { IconChevronRightSmall16, Label } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setNewbuildingBrokerCallbackWidgetOpened } from 'shared/actions/newbuildingBrokerOfferBooking/actions';
import { selectOfferBookingEnabled } from 'shared/selectors/newbuildingBrokerOfferBooking';

export function OfferBookingLabelContainer() {
  const dispatch = useDispatch();

  const handleClick = React.useCallback(() => {
    dispatch(setNewbuildingBrokerCallbackWidgetOpened(true));
  }, [dispatch]);

  const isOfferBookingEnabled = useSelector(selectOfferBookingEnabled);

  if (!isOfferBookingEnabled) {
    return null;
  }

  return (
    <Label
      color="accent-main-primary"
      background="accent-main-secondary"
      rightIcon={<IconChevronRightSmall16 color="icon-main-default" />}
      onClick={handleClick}
    >
      Онлайн-бронирование
    </Label>
  );
}
